import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import cx from "classnames";
import ConditionalLink from "components/ConditionalLink";
import { fullWidth as imageFullWidth } from "components/Design/ArtDirectedImage";

const DestinationCard = ({ image, title, to, fullWidth, height }) => {
  const content = (
    <div
      className={cx(
        "relative h-88 inline-flex w-full rounded-sm overflow-hidden",
        height,
        {
          "xl:w-full": fullWidth,
          "xl:w-157": !fullWidth,
        }
      )}>
      <GatsbyImage
        image={imageFullWidth(image)}
        className="w-full rounded-sm"
        imgClassName="rounded-sm select-none"
        loading="lazy"
        alt={title}
      />
      <div className="bg-card-overlay h-1/2 min-h-40 max-h-100 w-full absolute bottom-0 left-0 rounded-b-sm" />
      <div className="absolute bottom-0 left-0 py-8 px-10 z-10">
        <p className="font-cormorant uppercase font-bold text-white text-14-22 tracking-8">
          {title}
        </p>
      </div>
    </div>
  );

  const destinationCardContent = to ? (
    <ConditionalLink sameTab={true} link={to} className="grid lg:block">
      {content}
    </ConditionalLink>
  ) : (
    content
  );

  return destinationCardContent;
};

DestinationCard.defaultProps = {
  fullWidth: false,
};

export default DestinationCard;
